// extracted by mini-css-extract-plugin
export default {"reference":"Image_reference__8UYUm","productImage":"Image_productImage__jkew+","imageProductText":"Image_imageProductText__YBLdV"};